import React from 'react'
import Logo from 'components/Logo'

export default function Loading() {
	return (
		<div>
			<Logo />
			<style jsx>{`
				div {
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			`}</style>
		</div>
	)
}
